import { useMemo } from 'react'
import { ISelectOption } from 'types/IClassifier'
import useCustomerProfilesQuery from '../api/useCustomerProfilesQuery'

function useNctsProfileOptions(customerId: number | null, isExistingDeclaration: boolean): ISelectOption[] {
  const { data } = useCustomerProfilesQuery(customerId, isExistingDeclaration)

  return useMemo(
    () => (data ?? []).map<ISelectOption>(({ nctsProfileId, nctsProfileName }) => ({
      label: `${nctsProfileName}`,
      value: nctsProfileId,
    })),
    [data],
  )
}

export default useNctsProfileOptions
